// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"513":"038bd333","721":"2a818dd9"}[chunkId] + ".chunk.css";
};